import { useRef } from "react";
import PropTypes from "prop-types";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";

// A tooltip that also shows over a disabled control (for example "No
// permission"). PrimeReact's tooltipOptions.showOnDisabled moves the control
// into a wrapper div with direct DOM calls, outside React; React then throws
// NotFoundError when it inserts or removes a sibling of that control or the
// control itself, and the page crashes (E2E17). Here the wrapper is a span
// React owns, and the Tooltip targets that span: a disabled PrimeReact control
// ignores pointer events (.p-disabled), so the span still sees the hover.
export const TooltipTarget = ({ tooltip, tooltipOptions, children }) => {
  const targetRef = useRef(null);
  // showOnDisabled is what this component replaces; the span is always hoverable
  // eslint-disable-next-line no-unused-vars
  const { showOnDisabled, ...options } = tooltipOptions || {};

  return (
    <span
      ref={targetRef}
      className="p-tooltip-target-wrapper"
      style={{ display: "inline-flex" }}
    >
      {children}
      {(tooltip && (
        <Tooltip target={targetRef} content={tooltip} {...options} />
      )) ||
        null}
    </span>
  );
};

TooltipTarget.propTypes = {
  tooltip: PropTypes.string,
  tooltipOptions: PropTypes.object,
  children: PropTypes.node,
};

// A PrimeReact Button whose tooltip is safe when the button is disabled and
// when the buttons around it change. Takes the same props as Button.
const TooltipButton = ({ tooltip, tooltipOptions, ...buttonProps }) => (
  <TooltipTarget tooltip={tooltip} tooltipOptions={tooltipOptions}>
    <Button {...buttonProps} />
  </TooltipTarget>
);

TooltipButton.propTypes = {
  tooltip: PropTypes.string,
  tooltipOptions: PropTypes.object,
};

export default TooltipButton;
